<template>
    <div v-if="isShow" class="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50"
        @click.self="closePopup()">
        <div class="bg-white md:rounded-lg shadow-lg  md:w-[40%] w-[90%] h-min overflow-y-auto "
            :class="{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible }">
            <!-- Popup content -->
            <div class=" p-2 text-[16px] float-right"><font-awesome-icon :icon="['fas', 'xmark']" class="cursor-pointer"
                    @click="closePopup()" /></div>
            <div class="p-4">
                <div class="text-base font-bold">Chú ý : </div>
                <div class="text-sm mt-1 mb-1">Bạn chắc chắn muốn {{ propvalue }} phiếu này ?</div>
                <div>
                    <el-button  @click="deletebill(propvalue)" size="mini" type="danger"
                        plain>{{ propvalue }} phiếu</el-button>
                    <el-button  @click="closePopup()" size="mini" type="primary"
                        plain>Hủy</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL
export default {
    components: {

    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        deleteBillCode: {
            type: Number,
            default: null
        },
        propvalue: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            isVisible: true,
            billcode: ''
        };
    },
    watch: {
        deleteBillCode: {
            handler(newVal) {
                if (newVal) {
                    this.billcode = newVal
                }
            },
            deep: true, // Lắng nghe thay đổi sâu bên trong object
            immediate: true // Chạy ngay lần đầu tiên khi component được mount
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed');
            }, 200);
        },
        deletebill(value) {
            if (value == 'xóa') {
                this.$emit('deletebtn', this.billcode)
            }
            if (value == 'hủy') {
                this.$emit('updatebtn', this.billcode)
            }
            this.closePopup()
        }
    }
};
</script>

<style scoped>
@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>